import { Divider, Typography, useTheme } from "@mui/material";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { observer } from "mobx-react";
import React from "react";
import { stringReplacePluralizer } from "../../../utils/StringPluralizer";
import AcxMainExpansion from "../AcxMainExpansion";
import AcxDataGridStore from "./AcxDataGridStore";

const ContextRow = (
    index: number,
    renderer: ((row: GridRowModel) => React.ReactNode) | undefined,
    value,
): JSX.Element => {
    return (
        <React.Fragment key={`table-context-divider-${index}`}>
            <Divider variant={"fullWidth"} />
            <div style={{ padding: "8px" }}>{renderer?.(value)}</div>
        </React.Fragment>
    );
};

interface IGridSelection {
    store: AcxDataGridStore;
}

const AcxGridSelection = observer((props: IGridSelection) => {
    const theme = useTheme();

    const body = (
        <>
            {props.store.selectedRows?.map((value, index) => {
                return ContextRow(
                    index,
                    props.store.selectionContextOptions?.renderSelectedRow,
                    value,
                );
            })}
        </>
    );

    const count = props.store.selectedRows.length;

    return (
        <AcxMainExpansion
            expandable={count > 0}
            rootStyle={{
                boxShadow:
                    "0px 2px 2px -1px rgba(0,0,0,0.09), 0 1px 1px 0 rgba(0,0,0,0.07), 0px 1px 2px 0px rgba(0,0,0,0.05)",
            }}
            headerSx={{ userSelect: "none", height: "56px" }}
            header={
                <div>
                    <Typography
                        sx={{
                            color: "#1F1F1F",
                            fontSize: "13px",
                            letterSpacing: "0",
                            lineHeight: "24px",
                        }}
                    >
                        {count} Selected{" "}
                        {stringReplacePluralizer(
                            props.store.selectionContextOptions?.itemName ??
                                "Item",
                            count,
                            props.store.selectionContextOptions
                                ?.itemNamePluralized ?? "Items",
                        )}
                    </Typography>
                </div>
            }
            body={body}
            headerStyleOverRide={{
                0: {
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.common.white,
                },
                1: {
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.common.white,
                },
            }}
            bodyStyleOverRide={{
                0: {
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.common.white,
                },
                1: {
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.common.white,
                },
            }}
            chevronStyleOverRide={{
                0: {
                    color: theme.palette.secondary.main,
                },
                1: {
                    color: theme.palette.secondary.main,
                },
            }}
            headerMenu={(menuAnchor) =>
                props.store.selectionContextOptions?.action
            }
            alwaysShowHeaderMenu={Boolean(
                props.store.selectionContextOptions?.action,
            )}
        />
    );
});

export default AcxGridSelection;
